import Vue from 'vue';
export default Vue.component('tabmanager', {
    template:`
        <div class="block block-rounded">
            <ul class="nav nav-tabs nav-tabs-block" v-if="tabs !== null">
                <li v-for="tab in tabs" class="nav-item">
                    <a v-bind:href="'#'+tab.id" v-bind:class="[{ active: tab.isActive, disabled: !tab.isEnabled }, tab.cssClass, 'nav-link']" v-on:click="moveToTab($event, tab.index)">{{ tab.title }}</a>
                </li>
            </ul>
            <div class="block-content tab-content px-5 pt-5 pb-3">
                <!-- tab content -->
                <keep-alive>
                    <component :is="currentTabComponent" v-bind="currentTab" 
                        ref="activeTabComponent" 
                        v-on:submiterror="onTabSaveError" 
                        v-on:submit="onTabSaveSuccess"></component>
                </keep-alive>
                <!-- controlls -->
            </div>
            <div class="block-content block-content-full border-top">
                <div class="row">
                    <div class="col-md">
                        <button v-if="isPreviousButtonVisible()" v-on:click="moveToPreviousTab" class="btn btn-sm btn-dual">
                            <i class="si si-arrow-left fa-sm fa-fw ml-1"></i> {{ resources.previousButtonText }}
                        </button>
                    </div>
                    <div class="col-md text-right">
                        <button v-if="isNextButtonVisible()" v-on:click="moveToNextTab" class="btn btn-sm btn-dual mr-1">
                            {{ resources.nextButtonText }}<i class="si si-arrow-right fa-sm fa-fw mr-1"></i>
                        </button>
                        <button v-on:click="submitTab" v-if="isSaveButtonVisible()" class="btn btn-sm btn-primary" type="button">
                            {{ resources.saveButtonText }}
                        </button>
                    </div>
                </div> 
            </div>
        </div>
    `,
    computed:{
        currentTabComponent: function(){
            return this.currentTab !== undefined ? this.currentTab.componentType : null;
        }
    },
    props:{
        canMoveTab: Function,
        getTabContentUri: Function
    },
    methods:{
        getTab(index){
            return this.tabs[index];
        },         
        getActiveTab(){
            return this.tabs.find(o => o.isActive);
        },
        getNextTab(){
            return this.getTab(this.currentTab.index + 1);
        },
        showTab(targetTab){
            if(targetTab.isEnabled){
                this.currentTab.isActive = false;
                this.currentTab = targetTab;
                this.currentTab.isActive = true;
            }
        },
        moveToTab(event, index){
            event.preventDefault();
            this.showTab(this.getTab(index));
        },
        isSaveButtonVisible(){
            return this.currentTab !== undefined && this.currentTab.hasSaveOption;
        },
        isPreviousButtonVisible(){
            return this.currentTab !== undefined && this.currentTab.index > 0;
        },
        moveToPreviousTab(){
            this.showTab(this.getTab(this.currentTab.index - 1));
        },
        moveToNextTab(){
            this.showTab(this.getTab(this.currentTab.index + 1));
        },
        isNextButtonVisible(){
            if(this.currentTab !== undefined && (this.currentTab.index + 1) < this.tabs.length){
                return this.getTab(this.currentTab.index + 1).isEnabled;
            }          
            return false;
        },
        onTabSaveSuccess(showSuccessNotification){
            let nextTab = this.getNextTab();
            
            if(nextTab !== undefined && this.pageMode === 0){
                nextTab.isEnabled = true;
                this.showTab(nextTab);
            }

            if(showSuccessNotification){
                One.helpers('notify', { type: 'success', icon: 'fa fa-check mr-1', message: this.resources.saveWithSuccessMessage });
            }            
        },
        onTabSaveError(){
            One.helpers('notify', { type: 'danger', icon: 'fa fa-exclamation-triangle mr-1', message: this.resources.saveWithoutSuccessMessage });
        }
    },
    mounted(){

    },
    created() {

    }
});